var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgApexanalyticCompanyEnrichment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "m11.979 13.135-.007.01.002.006-.015.023-.026.043q-.013.021-.03.049l-.065.111-.059.104-1.48 2.523a1.7 1.7 0 0 1-.244.311 1 1 0 0 1-.098.08.64.64 0 0 1-.358.105H7.5l2.8-4.63-2.453-3.971-.245-.399h2.232c.179 0 .315.03.418.095a.75.75 0 0 1 .254.288l2.165 3.802.079.136zm1.973-1.887L16.5 7.5h-2.239q-.225 0-.389.117a1 1 0 0 0-.262.294l-.86 1.374 1.13 1.85.07.115zm2.321 4.837L14.02 12l-.01.019-.758 1.39-.005.007-.005.008a8 8 0 0 0-.172.316l-.008.015-.008.015-.304.559.846 1.639a1.5 1.5 0 0 0 .25.346.64.64 0 0 0 .47.186H16.5l-.23-.416z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApexanalyticCompanyEnrichment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apexanalytic-company-enrichment.ab67c20b.svg";